export default function smsAuthHeader() {
  let user = JSON.parse(localStorage.getItem('user'));
  if (user && user.token) {
    return {
      "Content-Type": "multipart/form-data",
      "Authorization": 'Bearer ' + user.token
    };
  } else {
    return {};
  }
}



// WEBPACK FOOTER //
// ./src/service/sms-auth-headers.js